
import { request } from "../utils/request.js"

export const customizeOrder_exportForManage = (pojo, args) => request({
    url: 'customizeOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOrder_getSumDataForManage = (pojo, args) => request({
    url: 'customizeOrder/getSumDataForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: false,
    ...args
})


export const customizeOrder_findPageForManage = (pojo, args) => request({
    url: 'customizeOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOrder_findPageListForManage = (pojo, args) => request({
    url: 'customizeOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'customizeOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'customizeOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOrder_findPageForSelect = (pojo, args) => request({
    url: 'customizeOrder/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOrder_findPageListForSelect = (pojo, args) => request({
    url: 'customizeOrder/findPageListForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOrder_saveIntoDraft = (pojo, args) => request({
    url: 'customizeOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'customizeOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOrder_update = (pojo, args) => request({
    url: 'customizeOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOrder_updateAndSubmit = (pojo, args) => request({
    url: 'customizeOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOrder_submitById = (id, args) => request({
    url: 'customizeOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOrder_deleteById = (id, args) => request({
    url: 'customizeOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOrder_approval = (pojo, args) => request({
    url: 'customizeOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOrder_findById = (id, args) => request({
    url: 'customizeOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const customizeOrder_findByIdIn = (params, args) => request({
    url: 'customizeOrder/findByIdIn',
    method: 'POST',
    params: params,
    showFailMessage: true,
    ...args
})

export const customizeOrder_findVoById = (id, args) => request({
    url: 'customizeOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const customizeOrder_generatePrintPdf = (pojo, args) => request({
    url: 'customizeOrder/generatePrintPdf',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOrder_updateOtherCost = (pojo, args) => request({
    url: 'customizeOrder/updateOtherCost',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})



// WEBPACK FOOTER //
// ./src/api/customizeOrder.js